
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { ClearVesselMouRequest, ClearVesselMouResponse, VerifyMouDataModel, VesselMousEnum } from "../models/mou.models";
import { EventAggregator } from "aurelia-event-aggregator";
import { Router } from "aurelia-router";
import { MyVesselsRouteConstants } from "../constants/route.constants";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { TaskService } from "@rightship-tech/tasks-ui/services/task.service";
import moment from "moment";

@autoinject()
export class MouService {

    private _rightShipPlatformApi: string;
    
    constructor(private requestClientService: RequestClientService, private configService: ConfigService, 
        private eventAggregator: EventAggregator, private router: Router,
        private notificationService: NotificationClientService, private taskService: TaskService) {
        this._rightShipPlatformApi = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/Vessel`;
    }

    //clear vessel mou
    public async clearVesselMou(request: ClearVesselMouRequest): Promise<ClearVesselMouResponse> {
        try {
            return await this.requestClientService.post<ClearVesselMouResponse>(`${this._rightShipPlatformApi}/ClearVesselMou`, {}, request);
        }
        catch (e) {
            console.error(e);
        }
    }

    public async verifyMouData(request: VerifyMouDataModel)
    {
        try{
            let mouClearSuccessful = false;
            for(let mouName of request.mouNames) 
            {
                let response = await this.clearVesselMou({ vesselId: request.vesselId, mou: VesselMousEnum[mouName] });
                mouClearSuccessful = response?.isSuccessFull == true;
                if(!mouClearSuccessful)
                    break;
            }
            if(!mouClearSuccessful)
            {
                this.notificationService.show("Error", "Error clearing MOU data", NotificationType.Error);
                return;
            }
            
            
            if(request.subtaskGuid)
            {
                await this.taskService.replyTaskCorrespondence(request.subtaskGuid, null
                    , `<p>This is an automated email.</p><br /><br /><p>User confirmed the vessel has${request.subjectToPsc? '': ' not'} been the subject of a recent ${request.mouNames.join(" MOU, ")} MOU Port State Control Inspection</p>`,
                    true, false, false, null, null, null, null, null
                );
            }

            await this.taskService.setAsClosed(request.subtaskId);
            this.notificationService.show("MOU data successfully verified", `MOU data verified on ${moment().format(ConfigService.instance()?.config?.common?.defaultDateTimeFormat)}`, NotificationType.Success);
        }catch(e){
            console.error(e);
            this.notificationService.show("Error", "Error clearing MOU data", NotificationType.Error);
        }
    }

    public submitPsc(vesselId: number, vesselImo: string, vesselName: string, mouNames: string[], subtaskGuid: string, subtaskId: number)
    {
        const pscSubmittedKey: string = `psc-submitted-${vesselId}`;
        this.eventAggregator.subscribe(pscSubmittedKey, async (pscId: number) => {
            if(pscId > 0)
            {
                await this.verifyMouData({ vesselId: vesselId, mouNames: mouNames, subtaskId: subtaskId, subtaskGuid: subtaskGuid, subjectToPsc: true });
            }
        });
        this.router.navigateToRoute(MyVesselsRouteConstants.AddPsc, {id: 0, vesselId: vesselId, identifier: vesselImo, vesselName: vesselName, onSubmitEventKey: pscSubmittedKey});
    }
}